import './AssemblyKitSelector.scss';

interface IProps {
  kitsQuantity: number;
  activeKit: number;
  setActiveKit: (activeKit: number) => void;
}

export const AssemblyKitSelector = ({kitsQuantity, activeKit, setActiveKit}:IProps) => {
  const kits = () => {
    return Array.from({length: kitsQuantity}, (_, i) => i);
  }
  return (
    <div className='assembly-vew_kit-selector'>
      {kits().map((kit, i) => (
        <div
          key={i}
          className={`assembly-vew_kit${(activeKit === kit)?' active':''}`}
          onClick={() => setActiveKit(kit)}
        >
          {kit+1}
        </div>
      ))}
    </div>
  )
}
